export enum CourseEnum {
  Basic = 'business-camp-basic',
  Express = 'business-camp-express',
  Advanced = 'business-camp-advanced',
}
